import axios from "axios";

// Casi todos los catch del sistema hacen `error.response.data` directo para armar el
// mensaje del Swal. Eso funciona cuando el servidor contesta con un error, pero NO
// cuando el error es de red -- servidor caido, sin internet, CORS, timeout -- porque
// ahi axios no trae `response` y la linea revienta con
// "Cannot read properties of undefined (reading 'data')", que en desarrollo tapa la
// pantalla con el overlay rojo y en produccion deja la accion sin ningun aviso.
//
// En vez de tocar los ~390 catch repartidos por el sistema, aqui se le rellena al error
// una respuesta sintetica: asi cada catch sigue leyendo `error.response.data` como
// siempre, pero encuentra un texto entendible en lugar de tronar.
const SIN_CONEXION = ["ERR_NETWORK", "ECONNREFUSED", "ECONNRESET", "ENOTFOUND", "EAI_AGAIN"];
const POR_TIEMPO = ["ECONNABORTED", "ETIMEDOUT"];

const mensajeDeRed = (error) => {
  const codigo = error.code || "";
  if (POR_TIEMPO.includes(codigo)) return "El servidor tardo demasiado en responder. Intenta de nuevo.";
  // en el navegador axios 0.x marca la caida de conexion con este mensaje, no con un codigo
  if (SIN_CONEXION.includes(codigo) || error.message === "Network Error") {
    return "No se pudo conectar con el servidor. Revisa tu conexion o avisa a soporte.";
  }
  return error.message || "No se pudo completar la operacion.";
};

// El back contesta las validaciones como { message, campo }. Los catch del sistema
// pintan `${error.response.data}`, y un objeto ahi sale como "[object Object]".
// Se le da forma de texto que ADEMAS conserva .message y .campo, para que sirvan
// las tres formas de leerlo que hay en el codigo.
const legible = (data) => {
  if (!data || typeof data !== "object" || typeof data.message !== "string") return data;
  const texto = new String(data.message); // eslint-disable-line no-new-wrappers
  texto.message = data.message;
  if (data.campo) texto.campo = data.campo;
  return texto;
};

axios.interceptors.response.use(
  (respuesta) => respuesta,
  (error) => {
    if (error && !error.response) {
      error.response = { status: 0, data: mensajeDeRed(error) };
    } else if (error && error.response) {
      error.response.data = legible(error.response.data);
    }
    return Promise.reject(error);
  }
);

export default axios;
